<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>Kunden</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-data-table style="width: 70vw;"
      :headers="headers"
      :items="customers.items.items"
      :rows-per-page-items="[5,10,20,50,100]"
      :loading="isLoading"
      :total-items="totalItems"
      :must-sort="true"
      :pagination.sync="pagination"
      class="elevation-1"
    >
      <template slot="items" slot-scope="props">
        <tr @click="tableClicked(props.item)">
        <td>{{ props.item.absa }}</td>
        <td class="text-xs-left">{{ props.item.name }}</td>
        <td class="text-xs-left">{{ props.item.name2 }}</td>
        <td class="text-xs-left">{{ props.item.street }}</td>
        <td class="text-xs-left">{{ props.item.zip }}</td>
        <td class="text-xs-left">{{ props.item.city }}</td>
        </tr>
      </template>
    </v-data-table>
    <v-dialog v-model="showDetail" transition="dialog-bottom-transition" max-width="700px">
      <CustomerDetail :customer="selectedCustomer"></CustomerDetail>
    </v-dialog>
  </div>
</template>

<script>
import CustomerDetail from './CustomerDetail.vue';
export default {
  name: 'customer',
  components: {
    CustomerDetail: CustomerDetail
  },
  data() {
    return {
      showDetail: false,
      selectedCustomer: {},
      totalItems: 0,
      pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 10,
        sortBy: 'absa'
      },
      headers: [
        {
          text: 'Absatzstätte',
          align: 'left',
          sortable: true,
          value: 'absa'
        },
        {
          text: 'Name',
          align: 'left',
          sortable: true,
          value: 'name'
        },
        {
          text: 'Zusatz',
          align: 'left',
          sortable: false,
          value: 'name2'
        },
        {
          text: 'Straße',
          align: 'left',
          sortable: true,
          value: 'street'
        },
        {
          text: 'PLZ',
          align: 'left',
          sortable: true,
          value: 'zip'
        },
        {
          text: 'Ort',
          align: 'left',
          sortable: true,
          value: 'city'
        }
      ]
    };
  },
  watch: {
    pagination(newValue, oldValue) {
      this.getDataFromApi();
    },
    customers(newValue, oldValue) {
      console.log(newValue.items.total);
      this.totalItems = newValue.items.total;
    }
  },
  mounted() {
    this.getDataFromApi();
  },
  computed: {
    customers() {
      return this.$store.state.customers.all;
    },
    isLoading() {
      return this.$store.state.customers.loading;
    }
  },
  methods: {
    getDataFromApi() {
      const perpage = this.pagination.rowsPerPage;
      const page = this.pagination.page;
      const sortby = this.pagination.sortBy;
      const descending = this.pagination.descending;

      this.$store.dispatch('customers/getAll', {
        perpage,
        page,
        sortby,
        descending
      });
    },
    tableClicked(customer) {
      this.showDetail = true;
      this.selectedCustomer = customer;
      console.log(customer);
    }
  }
};
</script>
<style>
.vv-dialog {
  box-shadow: none;
  -webkit-box-shadow: none;
}
</style>
